import FlaggedToken from 'owa-search-service/lib/data/schema/FlaggedToken';
import getScenarioStore from '../selectors/getScenarioStore';
import { mutatorAction } from 'satcheljs';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';
import { QueryAlterationType } from 'owa-search-service';

export default mutatorAction('setSpellerData', function setAlteredQuery(
    alteredQuery: string,
    suggestedSearchTerm: string,
    suggestedSearchTermReferenceId: string,
    flaggedTokens: FlaggedToken[],
    recourseQuery: string,
    scenarioId: SearchScenarioId,
    queryAlterationType: QueryAlterationType
) {
    const store = getScenarioStore(scenarioId);

    store.alteredQuery = alteredQuery;
    store.suggestedSearchTerm = suggestedSearchTerm;
    store.suggestedSearchTermReferenceId = suggestedSearchTermReferenceId;
    store.flaggedTokens = flaggedTokens;
    store.recourseQuery = recourseQuery;
    store.queryAlterationType = queryAlterationType;
});
